"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
class ServiceBilling extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get service billing status
     * @param clientId - clientId of service
     * @returns all info of service (services, identities, billingPlan, verifications)
     */
    async getServiceBillingStatus(clientId) {
        try {
            const data = await this._apiV2.serviceBillingAPI.getServiceBillingStatus(clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get billing company info
     * @param clientId - clientId of service
     * @returns all info of billing company (services, company, paymentMethod)
     */
    async getBillingCompanyInfo(clientId) {
        try {
            const data = await this._apiV2.serviceBillingAPI.getBillingCompanyInfo(clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get latest billing invoice
     * @param clientId - clientId of service
     * @returns latest invoice info
     */
    async getLatestBillingInvoice(clientId) {
        try {
            const data = await this._apiV2.serviceBillingAPI.getLatestBillingInvoice(clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = ServiceBilling;
